<template>
  <div class="container">
    <!-- Main view element -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/App.vue